import { memo } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import Typography from "components/Typography";
import type { TypographyProps } from "@mui/material";
import type { DivProps } from "components/primitives/Div";

const Container = styled("div")(({ theme }) => ({
  padding: theme.spacing(1, 2),
  textAlign: "center",
}));

interface AutocompleteNoOptionsTextProps {
  slotProps?: {
    root?: DivProps;
    typography?: TypographyProps;
  };
}

function AutocompleteNoOptionsText(props: AutocompleteNoOptionsTextProps) {
  const { slotProps } = props;
  const { t } = useTranslation();

  return (
    <Container {...slotProps?.root}>
      <Typography variant="TextS" sx={{ color: "primary.main" }} {...slotProps?.typography}>
        {t("global.no_options_found")}
      </Typography>
    </Container>
  );
}

export default memo(AutocompleteNoOptionsText);
